import { Play } from 'lucide-react'
import { cn } from '@shared/lib/cn'
import { youtubeThumbnailUrl } from './youtube'

export interface VideoPreviewProps {
  videoId: string
  /** Альтернативный текст картинки. */
  alt: string
  onClick: () => void
  /** Подпись поверх низа превью. Оформление текста задаёт вызывающий. */
  caption?: React.ReactNode
  className?: string
}

/** Превью ролика YouTube с кнопкой Play. Сам плеер открывает `VideoPlayerDialog`. */
export function VideoPreview({ videoId, alt, onClick, caption, className }: VideoPreviewProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'group relative w-full cursor-pointer overflow-hidden rounded-2xl',
        'focus-visible:ring-orange focus-visible:ring-2 focus-visible:outline-none',
        className
      )}
    >
      <img
        src={youtubeThumbnailUrl(videoId)}
        alt={alt}
        className="aspect-video w-full object-cover"
      />
      <div className="absolute inset-0 flex items-center justify-center bg-black/30 transition-colors group-hover:bg-black/40">
        <div className="bg-orange flex size-10 items-center justify-center rounded-full text-white">
          <Play className="size-5 fill-current" />
        </div>
      </div>
      {caption && (
        <div className="absolute right-0 bottom-0 left-0 bg-gradient-to-t from-black/60 to-transparent p-3">
          {caption}
        </div>
      )}
    </button>
  )
}
